/**
 * Who may see online-staff presence in the sidebar.
 * Matches backend `/dashboard/online-users` role_required(["admin"]).
 */
export function canViewOnlineStaffPresence(roleLike) {
  const r = String(roleLike ?? "")
    .trim()
    .toLowerCase();
  return r === "admin";
}
